const uuid = (prefix: string = '') => {
  // @ts-ignore (msCrypt is for Internet Explorer 11)
  const crypto = window.crypto;
  const array = new Uint32Array(1);
  crypto.getRandomValues(array);

  return `${prefix}${array.toString()}`;
};

export default uuid;
